import Login from "./login.page";

export default Login;
